<template>
  <div class="module-wrap module-knowlege-miss">
    <h2 >{{moduleTitle}}</h2>
    <div class="chart-title">
      <h5 class="ch-title">知识漏洞趋势</h5>
      <ChartLi :list="chartliList" />
    </div>

    <div class="chart-wrap">
      <div :id="chartId" class="chart"></div>
    </div>

    <div class="chart-drag-notice" v-if="isShowDragNotice">左右拖拽查看更多数据</div>
  </div>
</template>

<script>
/* eslint-disable */

import ChartLi from './ChartLi';
import { intToChinese } from '@/pages/dl-web/utils/index';

export default {
  name: 'ModuleKnowlegeMiss',
  data() {
    return {
      chartliList: [
        { color: '#00B1FF', name: 'my', text: '我的漏洞' },
        { color: '#FF9A42', name: 'avarge', text: '参考值' },
      ],
      isShowDragNotice: false,
      intervalNum: 0,
    };
  },

  props: {
    moduleTitle: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      require: true,
    },
    chartId: {
      type: String,
      required: true,
    },
    missData: {
      type: Array,
      required: true,
    },
  },

  components: {
    ChartLi,
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      const _this = this;
      const xData = []; const data1 = []; const
        data2 = [];

      this.missData.forEach((item, index) => {
        xData.push(`${intToChinese(item.gradeId)}年级`);

        data1.push(item.defaultLoNum);

        data2.push(item.loopholeLoNum);
      });

      this.intervalNum = this.missData.length <= 8 ? 0 : Math.floor(this.missData.length / 8);

      const myChart = echarts.init(document.getElementById(this.chartId));

      const option = {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(255, 255, 255, 0)',
          textStyle: {
            color: '#333333',
            fontSize: 15,
            lineHeight: 21,
          },
          padding: 15,
          formatter: (params) => {
            // console.log(params)
            const html = `
            <div class='chart-tip-wrap'>
              <p class='char-tip-title'>漏洞个数：<span>${params.value}</span></p>
            </div>`;
            return html;
          },
        },
        legend: {
          orient: 'vertical',
          x: 'left',
          data: ['漏洞个数'],
        },
        xAxis: {
          type: 'category',
          splitLine: { show: false },
          data: xData,
          name: '',
          nameTextStyle: {
            color: '#666',
            fontSize: _this.isMobile ? 24 : 12,
          },
          nameLocation: 'end',
          axisTick: {
            alignWithLabel: true,
            lineStyle: {
              color: '#cccccc',
            },
          },
          axisLine: {
            lineStyle: {
              color: '#cccccc',
            },
            onZero: false,
          },
          axisLabel: {
            fontSize: _this.isMobile ? 24 : 12,
            color: '#666666',
            interval: 0, // this.intervalNum,
            // margin: 20,
            width: _this.isMobile ? 60 : 30,
            // rotate:10
            formatter(value, index) {
              if (value.length > 6) {
                value = `${value.slice(0, 6)}...`;
              }
              return value;
            },
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
          },
          // max:'100',
          name: '漏洞个数',
          nameTextStyle: {
            fontSize: _this.isMobile ? 20 : 10,
            color: '#666666',
            align: 'center',
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              opacity: 0.5,
            },
          },
          axisLabel: {
            fontSize: _this.isMobile ? 24 : 12,
            color: '#666666',
            align: 'center',
            formatter: (value, index) => {
              if (value > 0) {
                return value;
              }
              return value;
            },
          },
          axisTick: {
            show: false,
          },
        },
        dataZoom: [
          // {
          //   type: 'inside',
          //   zoomLock: true,
          //   // start: 1,
          //   // end: 35,
          //   startValue: 0,
          //   endValue: 3
          // }
        ],
        series: [
          {
            type: 'line',
            symbol: 'circle',
            symbolSize: _this.isMobile ? 20 : 12,
            smooth: false,
            itemStyle: {
              normal: {
                color: '#FF9A42',
                lineStyle: {
                  color: '#FF9A42',
                  width: 2,
                },
                borderColor: '#ffffff',
                borderWidth: _this.isMobile ? 4 : 2,
                shadowColor: 'rgba(151, 194, 252, 1)',
                shadowBlur: 2,
              },
            },
            data: data1,
          },
          {
            type: 'line',
            symbol: 'circle',
            symbolSize: _this.isMobile ? 20 : 12,
            smooth: false,
            itemStyle: {
              normal: {
                color: '#00B1FF',
                lineStyle: {
                  color: '#00B1FF',
                  width: 2,
                },
                borderColor: '#ffffff',
                borderWidth: _this.isMobile ? 4 : 2,
                shadowColor: 'rgba(151, 194, 252, 1)',
                shadowBlur: 2,
              },
            },
            data: data2,
          },
        ],
      };
      option.dataZoom.push({
        type: 'inside',
        zoomLock: true,
        startValue: 0,
        endValue: (this.missData.length - 1),
      });

      myChart.setOption(option);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
h2{
  width: 358px;
  height: 40px;
  margin: 58px auto 32px auto;
  font-size: 20px;
  line-height: 40px;
  text-align: center;
  background: url("~@/assets/img/sub_headbg.png") no-repeat;
  background-size: cover;
}
  .module-knowlege-miss {
    position: relative;
    .chart-title{
      position: relative;
      .ch-title{
        position: absolute;
        width: 117px;
        height: 28px;
        left: 32px;
        background: linear-gradient(90deg, #E4EAFF 0%, #E1F5FF 100%);
        border-radius: 14px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 28px;
        text-align: center;
      }
    }
    .chart-wrap {
      position: relative;
    }
    .chart {
      width: 666px;
      height: 360px;
      margin: 32px auto 0;
      .xAxis-label {
        width: 100px;
      }
    }
    .chart-drag-notice {
      position: absolute;
      top: 75px;
      right: 70px;
      font-size: 12px;
      color: #666;
    }
  }
  /deep/ .chart-tip-wrap{
    padding: 10px;
    font-size: 16px;
    color: #666;
    border: solid 1px #00B1FF;
    background: #fff;
    .char-tip-title{
      >span{
        color: #333;
      }
    }
  }

</style>
<style scoped>
  @media screen and (max-device-width: 1024px) {
    .chart {
      width: 300px;
    }
  }

</style>
